import { actions, types } from './requests'
export const GETARTICLERECAP_TYPES = {
    ...types('GETARTICLERECAP'),
}
export const GETARTICLERECAP_ACTIONS = {
    ...actions('GETARTICLERECAP'),
}
